const sortBestPlayers = (players, typeOfSort, jornadaReal) => {
	if (typeOfSort == 1) {
		players = players
			.filter(player => player.stats.goals !== 0 && player.stats.gamesLeague && player.stats.gamesLeague.gAsChaser !== 0)
			// .map(player => {
			// 	if (!player.stats.gameLeague) player.stats.gameLeague = {gAsKeeper: 0,gAsBeater: 0,gAsChaser: 0,gAsSeeker: 0};
			// 	return player;
			// })
			.sort((a, b) => b.stats.goals - a.stats.goals)
		//.slice(0,10);
	} else if (typeOfSort == 2) {
		players = players
			.filter(player => player.stats.assists !== 0 && player.stats.gamesLeague
				&& (player.stats.gamesLeague.gAsChaser + player.stats.gamesLeague.gAsKeeper !== 0))
			.sort((a, b) => b.stats.assists - a.stats.assists)
	} else if (typeOfSort == 3) {
		players = players
			.filter(player => (player.stats.offensiveRebounds + player.stats.defensiveRebounds) !== 0
				&& player.stats.gamesLeague
				&& (player.stats.gamesLeague.gAsKeeper !== 0 + player.stats.gamesLeague.gAsChaser !== 0))
			.sort((a, b) => (b.stats.offensiveRebounds + b.stats.defensiveRebounds) - (a.stats.offensiveRebounds + a.stats.defensiveRebounds))
	} else if (typeOfSort == 4) {
		players = players
			.filter(player => player.stats.gamesLeague
				&& player.stats.gamesLeague.gAsKeeper !== 0
				&& (player.stats.gamesLeague.gAsKeeper) >= Math.round(jornadaReal * 0.65))
			.sort((a, b) => {
				if (!a.stats.gamesLeague || !b.stats.gamesLeague) return -1
				const aRatio = a.stats.concededGoals / a.stats.gamesLeague.gAsKeeper;
				const bRatio = b.stats.concededGoals / b.stats.gamesLeague.gAsKeeper;

				if (a.stats.gamesLeague.gAsKeeper !== 0 && b.stats.gamesLeague.gAsKeeper !== 0) {
					// Both players have non-zero goals as a keeper
					if (aRatio < bRatio) return -1;
					if (aRatio > bRatio) return 1;
					return 0;
				} else if (a.stats.gamesLeague.gAsKeeper !== 0) {
					// Only player 'a' has non-zero goals as a keeper
					return 1;
				} else if (b.stats.gamesLeague.gAsKeeper !== 0) {
					// Only player 'b' has non-zero goals as a keeper
					return -1;
				}

				// Neither player has non-zero goals as a keeper
				if (aRatio < bRatio) return -1;
				if (aRatio > bRatio) return 1;
				return 0;
			});
	} else if (typeOfSort == 5) {
		players = players
			.filter(player => player.stats.gamesLeague
				&& player.stats.gamesLeague.gAsKeeper !== 0
				&& (player.stats.gamesLeague.gAsKeeper) >= Math.round(jornadaReal * 0.65))
			.sort((a, b) => (b.stats.saves / (b.stats.saves + b.stats.concededGoals)) - (a.stats.saves / (a.stats.saves + a.stats.concededGoals)))
	} else if (typeOfSort == 6) {
		players = players
			.filter(player => player.stats.snitchs !== 0 && player.stats.gamesLeague && player.stats.gamesLeague.gAsSeeker !== 0)
			.sort((a, b) => b.stats.snitchs - a.stats.snitchs)
	} else if (typeOfSort == 7) {
		players = players
			.filter(player => (player.stats.bludgersSaves + player.stats.bludgersThrown !== 0)
				&& player.stats.gamesLeague
				&& player.stats.gamesLeague.gAsBeater !== 0)
			.sort((a, b) => (b.stats.bludgersSaves + b.stats.bludgersThrown) - (a.stats.bludgersSaves + a.stats.bludgersThrown))
	} else if (typeOfSort == 8) {
		players = players
			.filter(player => (player.stats.dribbles + player.stats.bStolen + player.stats.progressions !== 0)
				&& player.stats.gamesLeague
				&& player.stats.gamesLeague.gAsChaser !== 0)
			.sort((a, b) => (b.stats.dribbles + b.stats.bStolen + b.stats.progressions) - (a.stats.dribbles + a.stats.bStolen + a.stats.progressions))
	} else if (typeOfSort == 9) {
		players = players
			.filter(player => (player.stats.faults + player.stats.bLost !== 0)
				&& player.stats.gamesLeague
				&& player.stats.gamesLeague.gAsChaser !== 0)
			.sort((a, b) => (b.stats.faults + b.stats.bLost) - (a.stats.faults + a.stats.bLost))
	} else if (typeOfSort == 10) {
		players = players
			.filter(player => (player.stats.goals + player.stats.assists + player.stats.defensiveRebounds + player.stats.offensiveRebounds + player.stats.dribbles + player.stats.bStolen + player.stats.progressions !== 0)
				&& player.stats.gamesLeague
				&& (player.stats.gamesLeague.gAsChaser + player.stats.gamesLeague.gAsKeeper !== 0))
			.sort((a, b) => (b.stats.goals + b.stats.assists + b.stats.defensiveRebounds + b.stats.offensiveRebounds + b.stats.dribbles + b.stats.bStolen + b.stats.progressions)
				- (a.stats.goals + a.stats.assists + a.stats.defensiveRebounds + a.stats.offensiveRebounds + a.stats.dribbles + a.stats.bStolen + a.stats.progressions))
	} else if (typeOfSort == 11) {
		players = players
			.filter(player => (player.stats.goals + player.stats.assists + player.stats.defensiveRebounds + player.stats.offensiveRebounds + player.stats.dribbles + player.stats.bStolen + player.stats.progressions !== 0)
				&& player.age <= 21
				&& player.stats.gamesLeague
				&& (player.stats.gamesLeague.gAsChaser + player.stats.gamesLeague.gAsKeeper !== 0))
			.sort((a, b) => (b.stats.goals + b.stats.assists + b.stats.defensiveRebounds + b.stats.offensiveRebounds + b.stats.dribbles + b.stats.bStolen + b.stats.progressions)
				- (a.stats.goals + a.stats.assists + a.stats.defensiveRebounds + a.stats.offensiveRebounds + a.stats.dribbles + a.stats.bStolen + a.stats.progressions))
	} else if (typeOfSort == 12) {
		players = players
			.filter(player => (player.stats.progressions) !== 0
				&& player.stats.gamesLeague
				&& (player.stats.gamesLeague.gAsKeeper !== 0 + player.stats.gamesLeague.gAsChaser !== 0))
			.sort((a, b) => (b.stats.progressions) - (a.stats.progressions))
	}

	players = players.slice(0, 10);

	return players
}

export default sortBestPlayers
